
namespace RioERP.Wallet {

    @Serenity.Decorators.registerClass()
    export class CreditJournalGrid extends Serenity.EntityGrid<CreditJournalRow, any> {
        protected getColumnsKey() { return CreditJournalColumns.columnsKey; }
        protected getDialogType() { return CreditJournalDialog; }
        protected getIdProperty() { return CreditJournalRow.idProperty; }
        protected getInsertPermission() { return CreditJournalRow.insertPermission; }
        protected getLocalTextPrefix() { return CreditJournalRow.localTextPrefix; }
        protected getService() { return CreditJournalService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}